import {
  FcCustomTooltipContentClasses,
  FinanceCalculatorTheme,
} from '@dxp-module/themes'
import { makeStyles } from '@mui/styles'

export const customTooltipContentStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcCustomTooltipContentClasses
>(
  ({ typography, palette, breakpoints }) => ({
    tooltipContent: {
      lineHeight: 2.2,
      whiteSpace: 'pre-line',
      '& b': {
        borderBottom: `1px solid ${palette.text.disabled}`,
        marginBottom: 10,
        paddingBottom: 12,
        fontWeight: 'normal',
        color: palette.primary.main,
        display: 'block',
        // TODO fix guidance linting error forbidden-style-keys
        // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
        fontSize: typography.fontSM,
      },
      [breakpoints.down(breakpoints.values.sm)]: {
        position: 'relative',
        top: 30,
      },
    },
  }),
  {
    name: 'FC_CustomTooltipContent',
  }
)
